import { Stack } from '@mui/material';
import { Button, Modal, ModalContent, ModalActions, ModalWrapper, Typography } from '@braskai/ui-kit';
import { ModalHeaderDefault } from '@/shared/ui/modal';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { useExecuteOneTime } from '@/shared/hooks-tmp/useExecuteOneTime';
import { GTMEvents } from '@/shared/thirdParty/gtm';
import { CreditSlider } from './CreditSlider';
import { useMinutesBuying } from '../model/useMinutesBuying';
import { usePrice } from '../model/usePrice';
import { UpgradeCard } from './UpgradeCard';
import { getBuyMinutesViewItemListEventData } from '../lib/getBuyMinutesViewItemListEventData';
import { useBuyMinutesModalStore } from '../model/useBuyMinutesModalStore';

const BuyMinutesModalComponent = () => {
  const onClose = useBuyMinutesModalStore((state) => state.close);
  const { totalMinutes, handleChangeMinutes, price, pricePerMin, product } = usePrice();
  const { isStripeCheckoutLoading, checkout } = useMinutesBuying(totalMinutes, price);

  const handleClose = () => {
    if (!isStripeCheckoutLoading) {
      onClose();
    }
  };

  useExecuteOneTime(() => {
    if (!product) {
      return;
    }

    MixpanelEvents.buyMinutesModalShown();
    const buyMinutesGtmData = getBuyMinutesViewItemListEventData({ price: pricePerMin, productId: product.id });
    GTMEvents.viewItemList(buyMinutesGtmData);
  });

  return (
    <Modal open onClose={handleClose} size="xs">
      <ModalHeaderDefault onClose={handleClose} title="Buy additional minutes" />

      <ModalContent noPadding>
        <Stack gap={16}>
          <CreditSlider onChange={handleChangeMinutes} pricePerMin={pricePerMin} />

          {pricePerMin > 1 ? <UpgradeCard onClose={onClose} /> : null}

          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack>
              <Typography variant="body-2-md">Price</Typography>
              <Typography variant="title-4-md" color="grey.500">
                ${pricePerMin}&times;{totalMinutes}
              </Typography>
            </Stack>
            <Typography variant="title-1-sb">${price}</Typography>
          </Stack>
        </Stack>
      </ModalContent>

      <ModalActions>
        <Button
          fullWidth
          size="lg"
          onClick={checkout}
          disabled={!price || isStripeCheckoutLoading}
          isLoading={isStripeCheckoutLoading}
          data-test-id="buy-minutes-modal-checkout-button"
        >
          Checkout
        </Button>
      </ModalActions>
    </Modal>
  );
};

export const BuyMinutesModal = () => (
  <ModalWrapper hook={useBuyMinutesModalStore}>
    <BuyMinutesModalComponent />
  </ModalWrapper>
);
